(function () {
  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(cents) {
    if (typeof cents !== 'number') return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function withWidth(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function fetchRecommendations(productId, intent) {
    return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function renderUpsell() {
    var wrap = document.getElementById('v3-cart-upsell');
    if (!wrap || wrap.dataset.v3Populated === '1') return;
    wrap.dataset.v3Populated = '1';

    var listEl = document.getElementById('v3-cart-upsell-list');
    var productId = wrap.getAttribute('data-product-id');
    if (!productId || !listEl) return;
    var excludeIds = (wrap.getAttribute('data-cart-product-ids') || '').split(',').filter(Boolean);

    fetchRecommendations(productId, 'complementary')
      .then(function (data) {
        if (data && data.products && data.products.length) return data;
        return fetchRecommendations(productId, 'related');
      })
      .then(function (data) {
        if (!data || !data.products) return;
        var products = data.products
          .filter(function (p) { return excludeIds.indexOf(String(p.id)) === -1; })
          .slice(0, 4);
        if (!products.length) return;

        listEl.innerHTML = products.map(function (p) {
          var variant = p.variants && p.variants[0];
          if (!variant) return '';
          var img = withWidth(p.featured_image, 160);
          return (
            '<div class="v3-cart-upsell__card">' +
            '<a href="' + p.url + '" class="v3-cart-upsell__media">' +
            (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" width="60" height="60" loading="lazy">' : '') +
            '</a>' +
            '<div class="v3-cart-upsell__info">' +
            '<a href="' + p.url + '" class="v3-cart-upsell__name">' + escapeHtml(p.title) + '</a>' +
            '<span class="v3-cart-upsell__price">' + formatPrice(variant.price) + '</span>' +
            '</div>' +
            '<button type="button" class="v3-cart-upsell__add" data-variant-id="' + variant.id + '" aria-label="Ajouter ' + escapeHtml(p.title) + ' au panier">+</button>' +
            '</div>'
          );
        }).join('');
        wrap.hidden = false;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.v3-cart-upsell__add');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '\u2026';

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || 'add failed');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });

  var drawerRoot = document.querySelector('#CartDrawer') || document.body;
  var observer = new MutationObserver(function () { renderUpsell(); });
  observer.observe(drawerRoot, { childList: true, subtree: true });

  renderUpsell();
})();